/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';

import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';

import styled from 'styled-components';
import { motion } from 'framer-motion';

import glasses from './20160821-GlassesFace-Trans-Back.png';

const Heading = styled.h3`
  margin-top: 0;
  margin-bottom: 0;
  text-align: center;
  font-size: 1.17em;
  font-weight: normal;
`;

const MotionImg = styled(motion.img).attrs((props: any) => ({
  clicked: props.clicked || false,
}))`
  cursor: ${(props) => (props.clicked ? 'grabbing' : 'grab')};
`;

const Home = (): JSX.Element => {
  const [clicked, setClicked] = useState(false);
  return (
    <>
      <MotionImg
        src={glasses}
        alt="glasses"
        animate={{ rotate: 360 }}
        transition={{ duration: 1 }}
        whileHover={{ scale: 1.2 }}
        whileTap={{ scale: 0.8 }}
        drag
        dragConstraints={{
          top: -100,
          bottom: 100,
          left: -100,
          right: 100,
        }}
        whileDrag={{ scale: 1.5 }}
        className="glasses"
        clicked={clicked}
        onMouseDown={() => setClicked(true)}
        onMouseUp={() => setClicked(false)}
      />
      <Heading>
        Stevie Ballantines - Thinking+Feeling Human, Computer Person
      </Heading>
      <Divider />
      <Button
        className="p-button-sm"
        icon="pi pi-github"
        tooltip="Github"
        tooltipOptions={{ position: 'bottom' }}
        onClick={() => window.open('https://github.com/stevielcb', '_blank')}
      />
      {' '}
      <Button
        className="p-button-sm"
        icon="pi pi-link"
        tooltip="LinkedIn"
        tooltipOptions={{ position: 'bottom' }}
        onClick={() => window.open(
          'https://linkedin.com/in/stevie-ballantines-a3079525/',
          '_blank',
        )}
      />
    </>
  );
};

export default Home;
